import React from 'react';

export const Disclaimer = () => {
    return (
        <>
            <div>
                {gettext(
                    '¹ Salary data reflects March 2025 US national averages reported by Indeed',
                )}
            </div>
            <div>
                {gettext(
                    'Job opening data reflects 2023 - 2033 projections reported by the US Bureau of Labor Statistics.',
                )}
            </div>
            <div>
                {gettext(
                    'Actual salary and openings may vary based on factors such as location, experience, and market conditions.',
                )}
            </div>
            <div>
                {gettext(
                    'Data should not be interpreted as guarantees of employment or salary outcomes.',
                )}
            </div>
        </>
    );
};
